import ProductRatingRenderer from './product-rating-renderer';
import { Overview } from './overview';
import { ListRenderer } from './list-renderer';
import ReviewsApi from '../api/reviews';
import { PaginationHandler } from '../pagination/handler';
import Selector from './selectors';

export class ReviewsRenderer {
  constructor() {
    this.api = new ReviewsApi();
    this.rating = new ProductRatingRenderer();
    this.overview = new Overview(this.onChangeFilter);
    this.reviews = new ListRenderer();
    this.pagination = new PaginationHandler(this.onChangePage);
    this.itemsPerPage = 12;
    this.currentPage = 1;
    this.skus = Selector.getAllProducts();

    window.addEventListener('resize', this.render);
  }

  setCurrentPage = (currentPage) => {
    this.currentPage = currentPage;
  };

  getTotalPages = (count) => (
    Math.ceil(count / this.itemsPerPage)
  );

  onRenderHeader = ({ data }) => {
    const { review_count: count, average_rating: average } = data;

    this.overview.render(average, count);
    this.rating.render(this.skus, average, count);
  };

  onRenderReviews = ({ data }) => {
    const { review_count: count, reviews } = data;
    const totalPages = this.getTotalPages(count);

    this.reviews.render(reviews);
    this.pagination.render(count, this.currentPage, totalPages);
  };

  initialize = ({ data }) => {
    this.onRenderHeader({ data });
    this.onRenderReviews({ data });
  };

  onChangeFilter = (value) => {
    this.skus = value;

    this.setCurrentPage(1);
    this.render();
  };

  render = (callback = this.initialize) => {
    this.api.getProductReviewData(
      this.skus,
      callback,
      this.itemsPerPage,
      this.currentPage
    );
  };

  onChangePage = (currentPage) => {
    this.setCurrentPage(currentPage);
    this.render(this.onRenderReviews);
  };
}
